import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "seq-hero" }
const _hoisted_2 = { class: "d-flex flex-column flex-md-row justify-content-between align-items-md-start" }
const _hoisted_3 = { class: "seq-hero__label-row mb-2" }
const _hoisted_4 = { class: "seq-hero__label" }
const _hoisted_5 = { class: "d-flex align-items-center flex-wrap" }
const _hoisted_6 = { class: "seq-hero__amount me-3" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("...")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("*******")
const _hoisted_9 = {
  key: 0,
  class: "seq-hero__trend d-flex align-items-center"
}
const _hoisted_10 = { class: "svg-icon svg-icon-4 ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_DashboardMoveControls = _resolveComponent("DashboardMoveControls")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.label), 1),
          _createVNode("button", {
            type: "button",
            class: "seq-hero__eye-btn",
            title: _ctx.isBalanceVisible ? 'Hide balance' : 'Show balance',
            "aria-label": _ctx.isBalanceVisible ? 'Hide balance' : 'Show balance',
            disabled: _ctx.isToggling || !_ctx.visibilityReady,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleBalanceVisibility && _ctx.toggleBalanceVisibility(...args)))
          }, [
            _createVNode("i", {
              class: ["fas", _ctx.isBalanceVisible ? 'fa-eye-slash' : 'fa-eye']
            }, null, 2)
          ], 8, ["title", "aria-label", "disabled"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            (!_ctx.visibilityReady)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_7
                ], 64))
              : (_ctx.isBalanceVisible)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.currencySymbol) + " " + _toDisplayString(_ctx.formattedAmount), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                    _hoisted_8
                  ], 64))
          ]),
          (_ctx.trend)
            ? (_openBlock(), _createBlock("span", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.trend) + " ", 1),
                _createVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Up-2.svg" })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_DashboardMoveControls, {
        variant: "on-dark",
        class: "seq-hero__move-controls"
      })
    ])
  ]))
}